<div class="post-completion-promo-modal">
  <div class="container">
    <button mat-icon-button class="close-btn" (click)="close()" [attr.aria-label]="'Close' | translate">
      <mat-icon fontSet="material-icons-outlined">close</mat-icon>
    </button>

    <div class="hero">
      <div class="icon-badge">
        <mat-icon fontSet="material-icons-outlined">campaign</mat-icon>
      </div>

      <p class="eyebrow">{{ eyebrow }}</p>
      <h2>{{ title }}</h2>
    </div>

    <div class="content">
      <div class="message-card">
        <span class="message-icon">
          <mat-icon fontSet="material-icons-outlined">search</mat-icon>
        </span>
        <div class="message" [innerHTML]="modalText"></div>
      </div>
    </div>

    <div class="actions">
      <button type="button" class="dismiss-button" (click)="close()">
        {{ dismissLabel }}
      </button>

      <button type="button" class="def-button cta-button" (click)="onCtaClick()">
        {{ buttonLabel }}
        <mat-icon fontSet="material-icons-outlined">arrow_forward</mat-icon>
      </button>
    </div>
  </div>
</div>
